import React from 'react';
import { Folder, ChevronRight } from 'lucide-react';
import { Folder as FolderType } from '../../types/documents';

interface FolderListProps {
  folders: FolderType[];
  onFolderClick: (folderId: string) => void;
  onFolderCreate: () => void;
}

export default function FolderList({ folders, onFolderClick, onFolderCreate }: FolderListProps) {
  return (
    <div className="border-b border-border-light">
      <div className="p-4">
        <h2 className="text-lg font-semibold text-text-primary mb-4">Folders</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {folders.map((folder) => (
            <button
              key={folder.id}
              onClick={() => onFolderClick(folder.id)}
              className="flex items-center gap-3 p-4 rounded-lg bg-background hover:bg-primary-50 
                       transition-colors text-left group"
            >
              <Folder className="w-6 h-6 text-primary-500" />
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-text-primary truncate">{folder.name}</h3>
                {folder.description && (
                  <p className="text-sm text-text-secondary truncate">{folder.description}</p>
                )}
              </div>
              <ChevronRight className="w-5 h-5 text-text-secondary group-hover:text-primary-500 
                                    transition-colors" />
            </button>
          ))}
        </div>

        {folders.length === 0 && (
          <div className="text-center py-8">
            <Folder className="w-12 h-12 text-text-secondary mx-auto mb-3" />
            <p className="text-text-secondary">No folders yet</p>
            <button
              onClick={onFolderCreate}
              className="mt-2 text-primary-500 hover:text-primary-600 font-medium"
            >
              Create a folder
            </button>
          </div>
        )}
      </div>
    </div>
  );
}